import { useAuth } from '../context/AuthContext';

/**
 * Returns the current user's permission booleans for a single module,
 * matching the role permission matrix in UsersRoles.js.
 *
 *   usePagePermissions('masterData', 'chartOfAccounts')
 *     → { canView, canEdit, canDelete }
 *
 * Use these booleans to hide/disable Add/Edit/Delete buttons and to guard
 * the corresponding handlers. Admin/Owner bypass is handled inside
 * hasPermission(), so this hook returns all-true for those users automatically.
 */
export default function usePagePermissions(category, key) {
  const { hasPermission } = useAuth();
  return {
    canView: hasPermission(category, key, 'view'),
    canEdit: hasPermission(category, key, 'edit'),
    canDelete: hasPermission(category, key, 'delete'),
    canPost: hasPermission(category, key, 'post'),
    // 'cancel' tick (2026-11-04) — only on documents that can be cancelled;
    // OFF unless ticked on the role (admin / owner always true).
    canCancel: hasPermission(category, key, 'cancel'),
    // Change SAVED records (2026-11-04). False for an "Add only" role; same as
    // canEdit for every role saved before the Add tick existed.
    canChange: hasPermission(category, key, 'change'),
  };
}
